export default {"src":"/_next/static/media/is.3c049174.svg","height":63,"width":63};